export const FETCH_CATEGORIES_PENDING = 'FETCH_CATEGORIES_PENDING';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_ERROR = 'FETCH_CATEGORIES_ERROR';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';


export const fetchMenuCategoryPending = () => ({
    type: FETCH_CATEGORIES_PENDING
});

export const fetchMenuCategorySuccess = categories => ({
    type: FETCH_CATEGORIES_SUCCESS,
    payload: categories
});

export const fetchMenuCategoryError = error => ({
    type: FETCH_CATEGORIES_ERROR,
    payload: error
});

export const selectedCategory = value => ({
    type: SELECT_CATEGORY,
    payload: value
});

export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const updateSearch = value => ({
    type: UPDATE_SEARCH,
    payload: value
});

export const UPDATE_HIDE_DISHES = 'UPDATE_HIDE_DISHES';
export const updateHideDishes = value => ({
    type: UPDATE_HIDE_DISHES,
    payload: value
});